import { render, staticRenderFns } from "./PlosR.vue?vue&type=template&id=c3983c72"
import script from "./PlosR.vue?vue&type=script&lang=js"
export * from "./PlosR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports